import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { FormSwitchInput } from "../../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { CategoriaAssistenciaForm, CategoriaAssistenciaSchema } from "../../../schemas/CategoriaAssistencia_lista/categoria_assistencia";
import { CategoriaAssistenciaLista } from "../../../../domain/models/categoria_assistencia_lista";

import DefaultFormInput from "../../../../../../common/components/default_form_input";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * CategoriaAssistenciaModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedCategoriaAssistencia: CategoriaAssistenciaLista | null;
  onClose: () => void;
  onSubmit: (form: CategoriaAssistenciaForm) => void;
  onOpenChangeHistory: () => void;
};

export const CategoriaAssistenciaModal = ({
  open,
  saving,
  loading,
  selectedCategoriaAssistencia,
  onClose,
  onSubmit,
  onOpenChangeHistory
}: Props) => {

  const hookForm = useForm<CategoriaAssistenciaForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(CategoriaAssistenciaSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedCategoriaAssistencia) {
        hookForm.setValue('status', selectedCategoriaAssistencia.status ?? 1);
        hookForm.setValue('categoria', selectedCategoriaAssistencia.descricao ?? '');
      } else {
        hookForm.reset({ status: 1 });
      }
    }
  }, [
    hookForm,
    open,
    selectedCategoriaAssistencia,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Categoria de Assistência Técnica"
      leftButtonSlot={
        selectedCategoriaAssistencia && (
          <PrimaryButton
            buttonColor="yellow"
            onClick={() => onOpenChangeHistory()}>
            <span className="text-xs">
              Historico de alterações
            </span>
          </PrimaryButton>
        )
      }
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-2 my-2">
        <FormSwitchInput
          name="status"
          reactHookForm={hookForm}
        />

        <DefaultFormInput
          name='categoria'
          label='Nome da Categoria'
          required={true}
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
};